import { Lock, Unlock, Gauge } from "lucide-react";
import { PRODUCT_MAP, fmt, dropProduct } from "@/lib/load/products";
import { ApiSymbol } from "@/components/load/ApiSymbol";

const Pocket = ({ c, i, load, onToggle, onPlan, t }) => {
  const p = load?.product && PRODUCT_MAP[load.product];
  return (
    <div className={`load-pocket ${c.locked_dry ? "dry" : ""}`} style={p ? { borderTopColor: p.text } : undefined} data-testid={`comp-box-${i}`}>
      <div className="load-pocket-head"><b>{c.name}</b>{c.double_bulkhead && <span className="load-db" data-testid={`comp-db-${i}`}>DB</span>}<span>{`${fmt(c.capacity)} gal`}</span></div>
      <div className="load-pocket-prod" data-testid={`comp-product-${i}`} style={p ? { color: p.text } : undefined}>
        {!c.locked_dry && p && <ApiSymbol p={p} size={14} />}{c.locked_dry ? t("DRY") : p ? <span className="product-upper">{p.name}</span> : "—"}
      </div>
      {load?.label && <div className="card-sub" data-testid={`comp-tank-${i}`}>{t("Drop to")} {load.label}</div>}
      <div className="load-pocket-gal" data-testid={`comp-gal-${i}`}>{`${fmt(load?.gallons)} gal`} <small>· {`${fmt(p ? c.capacity - load.gallons : c.capacity)} gal`} {t("empty")}</small></div>
      <div className="load-pocket-btns">
        <button type="button" className={`ghost-btn ${c.locked_dry ? "load-dry-on" : ""}`} onClick={() => onToggle(i)} data-testid={`lock-dry-btn-${i}`}>
          {c.locked_dry ? <><Lock size={14} />{t("Locked dry")}</> : <><Unlock size={14} />{t("Lock dry")}</>}
        </button>
        {p && load.gallons > 0 && (
          <button type="button" className="primary-btn load-plan" onClick={() => onPlan(load)} data-testid={`plan-drop-${i}`}
            title={dropProduct(load.product) ? "" : t("Gallons only — pick the grade on Plan a drop")}>
            <Gauge size={14} />{t("Plan this drop")}
          </button>
        )}
      </div>
    </div>
  );
};

export const PocketGrid = ({ compartments, loads, onToggle, onPlan, t }) => (
  <div className="load-pockets">
    {compartments.map((c, i) => <Pocket key={i} c={c} i={i} load={loads?.[i]} onToggle={onToggle} onPlan={onPlan} t={t} />)}
  </div>
);
